import { ColorType, useTheme } from "./AHTheme/AHTheme";
import { IconSize, useLayoutContext } from "./LayoutProvider";
import styles from "./AHIcon.module.css";
import React from "react";
import { useBoxStyle } from "./AHTheme/useBoxStyle";
import { useScaleFactor } from "./AHScaleFactor";

import createIconSet from "@expo/vector-icons/createIconSet";
import glyphMap from "./AHIcon/fonts/glyph-map.json";
import { StoresprintIconName } from "./AHIcon/fonts/icon-types";
import { BoxProps } from "./AHTheme/BoxProps";

// Create the icon set using the generated font and glyph map
const StoresprintIcons = createIconSet(
  glyphMap as Record<string, number>,
  "StoresprintIcons",
  "StoresprintIcons.ttf"
);

type SemanticIcons = "team" | "topic";

export type AHIconType = StoresprintIconName | SemanticIcons;

export function getIconName(type: AHIconType): StoresprintIconName {
  switch (type) {
    case "team":
      return "users";
    case "topic":
      return "routing";
    default:
      return type;
  }
}

export type AHIconProps = {
  type: AHIconType;
  size?: IconSize;
  color?: ColorType;
  customColor?: string;
  forceSize?: number;
} & BoxProps;

export function useAHIconSize(size: IconSize) {
  const layout = useLayoutContext();
  const sf = useScaleFactor();
  return layout.icon[size] * sf;
}

function AHIconC(props: AHIconProps) {
  const { type, color: c, size: s, customColor, forceSize } = props;
  const theme = useTheme();

  const {
    type: _type,
    color: _color,
    size: _s,
    customColor: _customColor,
    forceSize: _forceSize,
    ...boxProps
  } = props;

  // Always call hooks in the same order
  const boxStyle = useBoxStyle(boxProps);
  const _size = useAHIconSize(s ?? "small");

  const color = customColor ?? theme[(c as ColorType) ?? "darkerText"];
  const size = forceSize ?? _size;

  return (
    <StoresprintIcons
      name={getIconName(type)}
      color={color}
      size={size}
      style={[
        boxStyle,
        {
          $$css: true,
          _: styles.Icon,
        } as any,
      ]}
    />
  );
}

export const AHIcon = React.memo(AHIconC);
